export default "__VITE_ASSET__CZwizAin__"